import React from 'react'

const GlobalLights = ({ isActive }) => {
  return <>{isActive && <ambientLight color={'white'} intensity={0.5} />}</>
}

export default GlobalLights
